/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS209: Avoid top-level return
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LocalStorage {
  set(key, value) {
    return window.localStorage.setItem(key, value);
  }

  get(key) {
    return window.localStorage.getItem(key);
  }

  isSupported() {
    try {
      if (typeof window.localStorage === 'undefined') { return false; }
      window.localStorage.setItem("bptest", "abc");
      if (window.localStorage.getItem("bptest") !== "abc") { return false; }
      window.localStorage.removeItem("bptest");
      return true;
    } catch (error) {
      return false;
    }
  }
}

class CookieStorage {
  constructor() {
    this.data = this._getData();
  }

  set(key, value) {
    this.data[key] = value;
    return this._setData();
  }

  get(key) {
    return this.data[key];
  }

  isSupported() {
    return true;
  }

  _setData() {
    return this._setCookie(JSON.stringify(this.data));
  }

  _getData() {
    const cookie = this._getCookie("bpstorage");
    try {
      return JSON.parse(cookie) || {};
    } catch (error) {
      return {};
    }
  }

  _getCookie(name) {
    const cookieStart = `${name}=`;
    const cookieParts = document.cookie.split(";");

    for (var cookiePart of Array.from(cookieParts)) {
      while (cookiePart.charAt(0) === " ") {
        cookiePart = cookiePart.substring(1, cookiePart.length);
      }

      if (cookiePart.indexOf(cookieStart) === 0) {
        return decodeURIComponent(cookiePart.substring(cookieStart.length, cookiePart.length));
      }
    }

    return null;
  }

  _setCookie(data) {
    const date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 year
    return document.cookie = `bpstorage=${encodeURIComponent(data)}; expires=${date.toGMTString()}; path=/`;
  }
}

for (var storage of [new LocalStorage(), new CookieStorage()]) {
  if (storage.isSupported()) {
    window.Buyapowa.BrowserStorage = storage;
  }
}
